<!--增加赠品-->
<template>
  <div class="cus-modal">
    <OmsTable
      v-if="!isSelectStockIn"
      :jordan-table-config="tableConfig"
      @on-select="(s) => onSelect(s, 1)"
      @on-select-cancel="(s) => onSelectCancel(s, 1)"
      @on-select-all="(s) => onSelectAll(s, 1)"
      @on-select-all-cancel="(s) => onSelectAllCancel(s, 1)"
    />
    <div class="stock-in" v-if="isSelectStockIn">
      <div class="tip">
        <p><Icon type="md-alert" />优先展示根据平台单号匹配的待入库的退单，当匹配不到退单时展示匹配的可退的订单</p>
        <p><Icon type="md-alert" />当单据数据来源为退单时，物流单号不一致不允许合并入库</p>
      </div>
      <OmsTable
        :jordan-table-config="tableConfigStockIn"
        @on-select="(s) => onSelect(s, 2)"
        @on-select-cancel="(s) => onSelectCancel(s, 2)"
        @on-select-all="(s) => onSelectAll(s, 2)"
        @on-select-all-cancel="(s) => onSelectAllCancel(s, 2)"
      />
    </div>
    <OmsButton class="modal-footer" :btn-config="btnConfig" /> 
  </div>
</template>

<script>
  export default {
    props: {
      componentData: {
        type: Object,
        default: {},
      },
    },
    data() {
      return {
        backupData: {},
        btnConfig: {
          typeAll: 'default', // 按钮统一风格样式
          btnsite: 'right', // 按钮位置 (right , center , left)
          buttons: [
            {
              text: $it('com.cancel'), // 取消 按钮文本
              btnclick: () => {
                this.$parent.$parent.closeConfirm()
              } // 按钮点击事件
            },
            {
              type: 'primary', // 按钮类型
              text: $it('com.determine'), // 确定 按钮文本
              btnclick: () => {
                this.submit();
              }
            }
          ]
        },
        tableConfig: {
          indexColumn: true,
          isShowSelection: true,
          pageShow: true, // 控制分页是否显示
          border: true, // 是否显示纵向边框
          total: 0, // 设置总条数
          pageSizeOpts: [10, 20, 30], // 每页条数切换的配置
          pageSize: 10, // 默认每页条数100条，产品要求
          pageIndex: 1, // 页码
          selectionData: [],
          data: [],
          columns: [
            {
              title: $it('fL.platform_billNo'), // 平台单号
              key: 'SOURCE_CODE'
            },
            {
              key: 'ID',
              title: $it('tL.orderNo') // 订单编号
            },
            {
              key: 'USER_NICK',
              title: $it('tL.buyerNickname') // 买家昵称
            },
            {
              key: 'RECEIVER_NAME',
              title: $it('fL.consignee') // 收货人
            },
            {
              key: 'RECEIVER_MOBILE',
              title: $it('fL.consignee_phone') // 收货人手机号
            },
            {
              key: 'CP_C_PHY_WAREHOUSE_ENAME',
              title: $it('fL.delivery_warehouse') // 发货仓库
            },
            {
              key: 'CP_C_LOGISTICS_ENAME',
              title: $it('fL.logisticsCompany'), // 物流公司
            },
            {
              key: 'EXPRESSCODE',
              title: $it('fL.logisticsOrder_No') // 物流单号
            },
            {
              title: '操作',
              render: (h, params) => h('a',
                {
                  on: {
                    click: () => {
                      this.submit(params.row)
                    }
                  }
                },
                '确定'
              )
            },
          ],
          businessFormConfig: {
            formValue: {
              sourceCode: '',
              billNo: "",
              orderId: '',
              receiverName: '',
              userNick: '',
              receiverMobile: '',
              storeName: ''
            },
            formData: [
              {
                style: 'input',
                label: $it('fL.platform_billNo'), // 平台单号
                colname: 'sourceCode',
                width: '8',
              },
              {
                style: 'input',
                label: $it('fL.billNo'), // 单据编号
                colname: 'billNo',
                width: '8',
              },
              {
                style: 'input',
                label: $it('tL.orderNo'), // 订单编号
                colname: 'orderId',
                width: '8',
              },
              {
                style: 'input',
                label: $it('fL.consignee'), // 收货人
                colname: 'receiverName',
                width: '8',
              },
              {
                style: 'input',
                label: $it('tL.buyerNickname'), // 买家昵称
                colname: 'userNick',
                width: '8',
              },
              {
                style: 'input',
                label: $it('fL.consignee_phone'), // 收货人手机
                colname: 'receiverMobile',
                width: '8',
              },
              {
                style: 'dropSelect', // 输入框弹框单多选
                width: '8',
                itemdata: {
                  colid: 167606,
                  colname: 'CP_C_SHOP_ID', // 当前字段的名称
                  datelimit: 'all',
                  display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
                  fkdisplay: 'drp', // 外键关联类型
                  fkdesc: $it('other.shop'), // 店铺 
                  inputname: 'CP_C_SHOP_ID', // 这个是做中文类型的模糊查询字段，例如ENAME
                  isfk: true, // 是否有fk键
                  isnotnull: false, // 是否必填
                  isuppercase: false, // 是否转大写
                  name: $it('other.shop'), // 店铺 input前面显示的lable值
                  readonly: false, // 是否可编辑，对应input   readonly属性
                  reftable: 'CP_C_SHOP',
                  reftableid: 24475,
                  valuedata: '' // 这个是选择的值
                },
                oneObj: (val) => {
                  console.log(val);
                  this.tableConfig.businessFormConfig.formValue.storeName = val.valuedata
                }
              },
            ],
          },
          businessButtonConfig: {
            typeAll: 'default', // 按钮统一风格样式
            btnsite: 'right', // 按钮位置 (right , center , left)
            buttons: [
              {
                type: 'primary',
                text: '查询',
                btnclick: () => {
                  this.pickOrderQuery()
                 /*  let result = _.cloneDeep(this.tableConfig.data)
                  for (let key in this.tableConfig.businessFormConfig.formValue) {
                    let v = this.tableConfig.businessFormConfig.formValue[key]
                    if (v != '') {
                      console.log(v)
                      result = result.filter(i => i[key] == v.trim())
                    }
                  }
                  this.tableConfig.data = result
                  this.tableConfig.selection = [] */
                }
              }
            ]
          }
        },
        tableConfigStockIn: {
          indexColumn: true,
          isShowSelection: true,
          pageShow: false, // 控制分页是否显示
          border: true, // 是否显示纵向边框
          total: 0, // 设置总条数
          pageSizeOpts: [10, 20, 30], // 每页条数切换的配置
          pageSize: 10, // 默认每页条数100条，产品要求
          pageIndex: 1, // 页码
          selectionData: [],
          data: [],
          columns: [
            {
              title: '单据数据来源',
              key: 'REFUND_ORDER_SOURCE_TYPE'
            },
            {
              title: $it('other.shop'), // 店铺
              key: 'CP_C_SHOP_TITLE'
            },
            {
              title: $it('fL.platform_billNo'), // 平台单号
              key: 'TID',
              render: (h, params) => {
                let text
                if (params.row.REFUND_ORDER_SOURCE_TYPE == '订单') {
                  text = params.row.SOURCE_CODE
                } else {
                  text = params.row.TID
                }
                return h('span', {}, text)
              }
            },
            {
              key: 'ID',
              title: $it('tL.orderNo') // 订单编号
            },
            {
              title: $it('fL.chargebackNumber'), // 退单编号
              key: 'ORIG_RETURN_ORDER_ID'
            },
            {
              key: 'USER_NICK',
              title: $it('tL.buyerNickname') // 买家昵称
            },
            {
              key: 'RECEIVER_NAME',
              title: $it('fL.consignee') // 收货人
            },
            {
              key: 'RECEIVER_MOBILE',
              title: $it('fL.consignee_phone') // 收货人手机号
            },
            {
              key: 'CP_C_LOGISTICS_ENAME',
              title: $it('fL.logisticsCompany'), // 物流公司
            },
            {
              key: 'EXPRESSCODE',
              title: $it('fL.logisticsOrder_No') // 物流单号
            },
            {
              title: '操作',
              render: (h, params) => h('a',
                {
                  on: {
                    click: () => {
                      this.submit(params.row)
                    }
                  }
                },
                '确定'
              )
            },
          ]
        },
      }
    },
    computed: {
      isSelectStockIn() {
        return this.$parent.title == '选择入库单据'
      }
    },
    mounted() {
      this.initTable()
    },
    methods: {
      initTable(data) {
        if (this.isSelectStockIn) {
          // 选择入库单据
          let result = this.componentData.list.map(i => ({ 
            REFUND_ORDER_SOURCE_TYPE: this.componentData.type,
            ...i.ocBOrder,
            ...i.ocBReturnOrder
          }))
          this.tableConfigStockIn.data = result
        } else {
          // 选择单据
          const list = data.byOrder
          let result = list.map(i => ({ 
            ...i.ocBOrder,
            ...i.ocBReturnOrder,
            scanItemResult: i.scanItemResult
          }))
          this.tableConfig.data = result
          this.tableConfig.total = data.totalNum
        }
      },
      // 选择订单查询
      async pickOrderQuery() {
        const params = {
          pageSize: this.tableConfig.pageSize,
          pageNum: this.tableConfig.pageIndex,
          ...this.tableConfig.businessFormConfig.formValue,
        }
        const { data: { code, data }} = await this.service.orderCenter.queryByOrder(params)
        if (code == 0) {
          this.backupData = data
          this.initTable(data)
        }
      },
      submit(row) {
        const handler = () => {
          let list = []
          let result
          if (this.isSelectStockIn) {
            if (!row && !this.tableConfigStockIn.selectionData.length) {
              return $fcError('请选择入库单据')
            }
          } else {
            if (!row && !this.tableConfig.selectionData.length) {
              return $fcError('请选择单据')
            }
          }
          if (row) {
            list = [row]
          } else if (this.isSelectStockIn) {
            list = this.tableConfigStockIn.selectionData
          } else {
            list = this.tableConfig.selectionData
          }
          let idArr = list.map(i => i.ID)
          if (this.isSelectStockIn) {
            if (tip(list)) return
            result = this.componentData.list.filter(i => idArr.includes(i.ocBOrder.ID))
          } else {
            result = this.backupData.byOrder.filter(i => idArr.includes(i.ocBOrder.ID))
          }
          this.$parent.$parent.$parent.initTable(result, !this.isSelectStockIn)
          this.$parent.$parent.closeConfirm()
        }

        /**
         * 当单据数据来源为退单时，点击确认时，如果选中行的物流单号不一致，提示：“物流单号不一致”
         * 当单据数据来源为订单时，允许不同的物流单号的明细合并入库；
         */
        const tip = (list) => {
          let flag = false
          const isRe = list.some(i => i.REFUND_ORDER_SOURCE_TYPE == '退单')
          const arr = list.map(i => i.EXPRESSCODE)
          if (isRe && Array.from(new Set(arr)).length != 1) {
            this.$Message.warning('物流单号不一致')
            flag = true
          }
          return flag
        }
        if (!this.componentData.isEmptyStockInTable) {
          return this.$Modal.confirm({
            className: 'ark-dialog',
            title: '提示',
            content: '清空当前未完成单据继续扫描下一张单据？',
            width: 350,
            mask: true,
            showCancel: true,
            onOk: () => {
              handler();
            },
            onCancel: () => {
              // this.$parent.$parent.closeConfirm()
            },
          })
        }
        handler()
      },
      // 选中某一项时触发
      onSelect(selection, type) {
        let table = type == 2 ? 'tableConfigStockIn' : 'tableConfig'
        this[table].selectionData = selection;
      },
      // 取消选中某一项时触发
      onSelectCancel(selection, type) {
        let table = type == 2 ? 'tableConfigStockIn' : 'tableConfig'
        this[table].selectionData = selection;
      },
      // 点击全选时触发
      onSelectAll(selection, type) {
        let table = type == 2 ? 'tableConfigStockIn' : 'tableConfig'
        this[table].selectionData = selection;
      },
      // 点击取消全选时触发
      onSelectAllCancel(selection, type) {
        let table = type == 2 ? 'tableConfigStockIn' : 'tableConfig'
        this[table].selectionData = selection;
      },
    }
  };
</script>
<style lang="less" scoped>
  .tip {
    line-height: 22px;
    color: #717070;
    margin-bottom: 20px;
    p {
      display: flex;
      align-items: center;
    }
    .iconmd-alert {
      color: red;
      margin-right: 4px;
    }
  }
</style>
